import React, { useState } from 'react';
import { AppLayout } from './components/Layout/AppLayout';
import { DashboardView } from './components/Dashboard/DashboardView';
import { AnalyticsView } from './components/Analytics/AnalyticsView';
import { SettingsView } from './components/Settings/SettingsView';
import { SimpleAnalyticsView } from './components/Analytics/SimpleAnalyticsView';

type View = 'dashboard' | 'analytics' | 'settings';

class AnalyticsErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error: Error | null }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Analytics view error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <SimpleAnalyticsView />;
    }

    return this.props.children;
  }
}

// Inner component that has access to Weather API context
const AppContent: React.FC = () => {
  const [currentView, setCurrentView] = useState<View>('dashboard');

  return (
    <AppLayout currentView={currentView} onViewChange={setCurrentView}>
      {currentView === 'dashboard' && <DashboardView />}
      {currentView === 'analytics' && (
        <AnalyticsErrorBoundary>
          <AnalyticsView />
        </AnalyticsErrorBoundary>
      )}
      {currentView === 'settings' && <SettingsView />}
    </AppLayout>
  );
};

function App() {
  return <AppContent />;
}

export default App;
